import { PriceConfig } from '@/types/salary';

export const defaultPriceConfig: PriceConfig = {
  ru: {
    0: 330,
    10: 400,
    20: 500,
    30: 550,
    40: 600,
  },
  en: {
    0: 450,
    10: 550,
    20: 600,
    30: 650,
    40: 700,
  },
};
